import React from 'react';
import { makeConnect, makeObservableConsumer } from '../../infrastructure/components/mobx-extensions';
import { ZoomViewModel } from './zoom.viewmodel';

const ZoomContext = React.createContext<ZoomViewModel>(null);

const ZoomVMConsumer = makeObservableConsumer(ZoomContext);
const connectZoomVM = makeConnect(ZoomContext);

export { ZoomContext, ZoomVMConsumer, connectZoomVM };